import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import type { MetricValues } from '@/modules/finances/types';
import { usLocalizedNumber } from '@/modules/shared/lib/humanization';
import { getKeyMetric, getShortNameForMetric } from './cell-semi-annually';
interface CellMonthlyProps {
  title: string;
  isTotal?: boolean;
  className?: string;
  metrics: Partial<MetricValues>;
  activeMetrics: string[];
}
function CellMonthly(t0) {
  const $ = _c(17);
  const {
    metrics,
    title,
    isTotal: t1,
    className,
    activeMetrics
  } = t0;
  const isTotal = t1 === undefined ? false : t1;
  const t2 = isTotal && "bg-muted -my-4 py-4";
  const t3 = !isTotal && "after:border-border after:absolute after:left-0 after:h-12 after:border-r after:content-[\"\"]";
  let t4;
  if ($[0] !== className || $[1] !== t2 || $[2] !== t3) {
    t4 = cn("relative flex min-w-[87px] flex-col items-center justify-center font-medium", t2, t3, "2xl:min-w-[80px]", className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== title) {
    t5 = <div className="text-foreground mb-2 text-center text-xl leading-normal font-semibold">{title}</div>;
    $[4] = title;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== activeMetrics || $[7] !== metrics) {
    let t7;
    if ($[9] !== metrics) {
      t7 = (metric, index) => <div key={index} className="flex w-[70.5px] flex-col"><div className="text-muted-foreground mb-1 text-center text-xs leading-normal font-normal">{getShortNameForMetric(metric)}</div><div className="text-foreground text-center text-xs leading-normal font-semibold">{usLocalizedNumber(metrics[getKeyMetric(metric) as keyof MetricValues] ?? 0)}</div></div>;
      $[9] = metrics;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    t6 = activeMetrics.map(t7);
    $[6] = activeMetrics;
    $[7] = metrics;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <div className="flex flex-col">{t6}</div>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t7) {
    t8 = <div className={t4}>{t5}{t7}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
export { CellMonthly };